import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/common/components/base.component';
import { VisitorPlaceService } from 'src/app/modules/event-calendar/services/visitor.place.service';
import { VisitorPlace } from 'src/app/modules/shared/models/visitor.place';
import { frontendSettingsSelector } from 'src/app/modules/shared/ngrx.stores/frontend.settings/selectors';
import {
  IAppState,
  IFrontendSettings,
} from 'src/app/modules/shared/ngrx.stores/frontend.settings/states';

@Component({
  selector: 'ig-place-details-side-modal',
  templateUrl: './place.details.side.modal.component.html',
  styleUrls: ['./place.details.side.modal.component.scss'],
})
export class PlaceDetailsSideModalComponent extends BaseComponent {
  @Input() place: VisitorPlace;
  frontendSettings$: Observable<IFrontendSettings | null>;

  isShowingMore = false;

  @Output() public back = new EventEmitter();

  constructor(
    public activatedRoute: ActivatedRoute,
    public sanitizer: DomSanitizer,
    public eventService: VisitorPlaceService,
    private _store: Store<IAppState>
  ) {
    super({ activatedRoute });

    this.frontendSettings$ = this._store.pipe(
      takeUntil(this.isDestroyed),
      select(frontendSettingsSelector)
    );
  }

  // public isNeedScroll() {
  //   if (!this.descEle) return false;
  //   return (
  //     this.descEle.nativeElement.offsetHeight <
  //     this.descEle.nativeElement.scrollHeight
  //   );
  // }
}
